import Vue from "vue";
import VueRouter from "vue-router";
import Landing from "@/Landing.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/legal",
    name: "legal",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "@/pages/legal.vue")
  },
  {
    path: "/",
    name: "MerloCode",
    component: Landing
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
